import SiteAppsPresentation from 'components/SiteApps/SiteAppsPresentation'

export default {
  Presentation: SiteAppsPresentation,
}
